import React from "react"
import MissionsTitle from "../../../MissionsTitle"
import MissionsCTA from "../../../MissionsCTA"
import {Mission} from "../../../../models/secondary-nav"
import {ColumnsDefinition} from "../../../ResponsiveColumns"
import MissionCard from "../../../MissionCard"
import {Column} from "../../../ResponsiveColumns/component"
import {StyledResponsiveColumns} from "./component"

type MissionsProps = {
    data: Mission | null
    department: string
}

export const Missions = ({data, department}: MissionsProps) => {
    const definition: ColumnsDefinition = {
        xs: "100%",
        sm: "100%",
        md: "18rem",
        lg: {
            1: "12.375rem",
            2: "19.25rem",
            3: "19.25rem",
        },
        xl: {
            1: "12.375rem",
            2: "20.875rem",
            3: "20.875rem",
        },
    }
    if (!data) return null
    const {items, title, categoryLink, noOfColumns} = data
    const columnsGap = "1rem"
    return (
        <>
            {title && <MissionsTitle title={title} />}
            <StyledResponsiveColumns
                columnsDefinition={definition}
                nrOfColumns={noOfColumns}
                gap={columnsGap}
                data-testid="header-missions"
            >
                {items.map((item, index) => {
                    const key = `${categoryLink?.title}-${item.title}-${index}`
                    return (
                        <Column key={key} nrOfColumns={noOfColumns} gap={columnsGap}>
                            <MissionCard {...item} department={department} />
                        </Column>
                    )
                })}
            </StyledResponsiveColumns>
            {categoryLink && (
                <MissionsCTA title={categoryLink.title} department={department} target={categoryLink.target} />
            )}
        </>
    )
}

export default Missions
